export const QueryKey = {
  Countries: "countries",
  Provinces: "provinces",
  Cities: "cities",
  Areas: "areas",
  StudentDetails: "student-details",
  AllStudents: "all-students",
};
